export function mapStringToEnum<T extends Record<string, string | number>>(enumType: T, value: string): T[keyof T] {
    const enumValues = Object.values(enumType) as (string | number)[];
    if (enumValues.includes(value)) {
        return value as T[keyof T];
    }

    throw new Error(`Invalid value '${value}' for enum`);
}

export const pascalToLabel = (str: string): string => {
    // Insert space before capital letters not at the start
    return str
        .replace(/([a-z])([A-Z])/g, '$1 $2')   // camelCase or PascalCase
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') // handle ALLCAPS followed by CapitalLower
        .trim();
};
export function enumToOptions<T extends Record<string | number, string>>(e: T) {


    return Object.values(e).map((value) => ({
        value,
        label: pascalToLabel(String(value)),
    }));
}